export * from './colors';
export * from './categories';
export * from './quotes';
export * from './stoicQuotes';
export * from './subconsciousAffirmations';

// Ritual steps in order
export const RITUAL_STEPS = [
  'review',
  'unfinished',
  'capture',
  'plan-tomorrow',
  'reflection',
  'quote',
] as const;

export const RITUAL_STEP_LABELS: Record<(typeof RITUAL_STEPS)[number], string> = {
  review: 'Review Today',
  unfinished: 'Handle Unfinished',
  capture: 'Capture Tasks',
  'plan-tomorrow': 'Plan Tomorrow',
  reflection: 'Daily Reflection',
  quote: 'Affirmation',
};

// Default user settings
export const DEFAULT_USER_SETTINGS = {
  shutdownTime: '17:00',
  defaultBlockDuration: 30,
  theme: 'light' as const,
  defaultStartHour: 6,
  notifications: true,
  showRevisionMarks: true,
  sketchyLineStyle: true,

  // Cal Newport Features
  fixedScheduleEnabled: false,
  fixedScheduleEndTime: '17:00',
  fixedScheduleReminderMinutes: 15,
  showDeepWorkMetrics: true,
  weeklyPlanningEnabled: true,
  dayThemingEnabled: true,
};

// Timeline settings
export const TIMELINE_HOUR_HEIGHT = 80; // pixels per hour
export const TIMELINE_START_HOUR = 6; // 6 AM default
export const TIMELINE_END_HOUR = 22; // 10 PM default
export const BLOCK_MIN_DURATION = 15; // minutes

// Max revisions to keep
export const MAX_REVISIONS = 3;
